import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledPatientVisitsHistory = styled(StyledFlex)`
   padding-top: 1px;
   height: 100%;
`;
